class PrivateSupplyTheme {
  constructor() {
    this.bindUI();
    this.bindReveal();
    this.bindProductForms();
    this.bindPredictiveSearch();
    this.recentlyViewed();
  }

  bindUI() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-drawer-open], [data-drawer-close], [data-quick-view]');
      if (!trigger) return;
      if (trigger.matches('[data-drawer-open="cart"]')) document.body.classList.add('cart-open');
      if (trigger.matches('[data-drawer-open="search"]')) document.body.classList.add('search-open');
      if (trigger.matches('[data-drawer-close]')) document.body.classList.remove('cart-open', 'search-open', 'quick-view-open');
      if (trigger.matches('[data-mobile-menu-toggle]')) document.body.classList.toggle('mobile-menu-open');
      if (trigger.matches('[data-quick-view]')) {
        event.preventDefault();
        this.openQuickView(trigger.getAttribute('href'));
      }
    });
  }

  bindReveal() {
    const items = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !items.length) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });
    items.forEach((item) => observer.observe(item));
  }

  bindProductForms() {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form], .product-form');
      if (!form) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      submit?.setAttribute('disabled', 'disabled');
      try {
        await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        document.body.classList.add('cart-open');
        await this.refreshCart();
      } catch (error) {
        console.error(error);
      } finally {
        submit?.removeAttribute('disabled');
      }
    });
  }

  async refreshCart() {
    const response = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer');
    const current = document.querySelector('#CartDrawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  bindPredictiveSearch() {
    const input = document.querySelector('[data-predictive-input]');
    const results = document.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    let timeout;
    input.addEventListener('input', () => {
      clearTimeout(timeout);
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        return;
      }
      timeout = setTimeout(async () => {
        const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`;
        const response = await fetch(url);
        results.innerHTML = await response.text();
      }, 180);
    });
  }

  async openQuickView(url) {
    const modal = document.querySelector('[data-quick-view-modal]');
    if (!modal || !url) return;
    modal.querySelector('[data-quick-view-content]').innerHTML = '<div class="drawer__body">Loading...</div>';
    document.body.classList.add('quick-view-open');
    const response = await fetch(url + '?view=quick');
    modal.querySelector('[data-quick-view-content]').innerHTML = await response.text();
  }

  recentlyViewed() {
    const product = document.querySelector('[data-product-id]');
    const holder = document.querySelector('[data-recently-viewed]');
    const key = 'private_supply_recently_viewed';
    if (product) {
      const item = { id: product.dataset.productId, url: location.pathname, title: product.dataset.productTitle };
      const existing = JSON.parse(localStorage.getItem(key) || '[]').filter((x) => x.id !== item.id);
      localStorage.setItem(key, JSON.stringify([item, ...existing].slice(0, 8)));
    }
    if (holder) {
      const items = JSON.parse(localStorage.getItem(key) || '[]').filter((x) => x.url !== location.pathname);
      holder.innerHTML = items.slice(0, 4).map((item) => `<a class="trust-card" href="${item.url}">${item.title}</a>`).join('');
    }
  }
}

customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  }
});

document.addEventListener('DOMContentLoaded', () => new PrivateSupplyTheme());
